import { useTranslations } from "next-intl";
import Button from "@components/core/Button";
import IconSvg from "@components/core/IconSvg";

function ClosetValidationCompleteSubHeader({ setStep }) {
  const t = useTranslations("common");

  return (
    <div className="d-flex flex-column align-items-center bg-white py-3 px-4 text-center">
      <div
        style={{ width: "32px", height: "32px", stroke: "#13bb71" }}
        className="mb-2"
      >
        <IconSvg name="circle-success-tick" />
      </div>

      <h5 className="px-2 mb-2">
        {t("drawer.closet_is_validated_subheader.your_closet_is_validated")}
      </h5>
      <p className="px-2 mb-2">
        {t("drawer.closet_is_validated_subheader.we_will_prepare_it")}
      </p>
      <Button
        variant="link-primary"
        className="mx-auto font-weight-medium no-underline"
        onClick={() => setStep("nextStepsExplanation")}
      >
        {t("drawer.closet_is_validated_subheader.and_the_next_steps")}
      </Button>
    </div>
  );
}

export default ClosetValidationCompleteSubHeader;
